module.exports = __webpack_public_path__ + "img/thumb-d9.46146901.png";